module.exports = __webpack_public_path__ + "img/title.3cc457bc.png";